import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import Reviews from "../components/Reviews";

const ProductReviewsPage = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;


    useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
        }
        else {
            if(config.shopping_app_settings.need_login > 0 ) {
                navigate('/login');
            }
        }

    }, []);

    return (
        <React.Fragment>
           <Reviews />
        </React.Fragment>
    );
};

export default ProductReviewsPage;